import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { NAV_LINKS, DEMO_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { DgptLogo } from './DgptLogo';
import { cn } from '../../src/lib/utils';
export function DgptHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && setOpen(false);
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);
  return <header className={cn('sticky top-0 z-40 w-full border-b transition-colors duration-300', scrolled ? 'border-hairline bg-ink/90 backdrop-blur-xl' : 'border-transparent bg-ink/40 backdrop-blur-md')} data-id="element-47" data-mp="3b93ifjq0qsl6">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:z-50 focus:rounded-md focus:bg-lime focus:px-3 focus:py-2 focus:text-sm focus:font-medium focus:text-ink" data-id="element-48" data-mp="10heqq22s14tt">
        Skip to main content
      </a>

      <div className="mx-auto flex h-16 w-full max-w-[1320px] items-center justify-between gap-6 px-4 sm:px-6 lg:h-[72px] lg:px-8" data-id="element-49" data-mp="cltymdiw7mvx">
        <a href="#top" aria-label="DiligenceGPT — home" className="shrink-0 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-4 focus-visible:ring-offset-ink" data-id="element-50" data-mp="hkdjsbpnwun8">
          <DgptLogo data-id="element-51" data-mp="1xz6f5ri0nndb" />
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-52" data-mp="1xxvalpgqybl5">
          <ul className="flex items-center gap-9" data-id="element-53" data-mp="22woqtpnf4gp0">
            {NAV_LINKS.map(link => <li key={link.label} data-id="element-54" data-mp="2up61ndpehap">
                <a href={link.href} className="text-[11px] font-medium uppercase tracking-[0.16em] text-text-secondary transition-colors hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-4 focus-visible:ring-offset-ink" data-id="element-55" data-mp="2tniijfi42c3">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-56" data-mp="3bbk0cegfqtd6">
          <CtaButton href={DEMO_URL} event="nav_book_demo_click" className="hidden sm:inline-flex" data-id="element-57" data-mp="3bcv4ifdsm34t">
            Book a Demo
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-58" data-mp="3p49k0c8hrm74" />
          </CtaButton>
          <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-controls="mobile-menu" className="inline-flex h-11 w-11 items-center justify-center rounded-lg border border-hairline text-text-secondary transition-colors hover:border-lime/50 hover:text-lime focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime lg:hidden" data-id="element-59" data-mp="3k9vnu7m09b1e">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-60" data-mp="28jqxj9svv2fj" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-61" data-mp="2dhipg3tj2ojq" />}
            <span className="sr-only" data-id="element-62" data-mp="2di0xdxpjyr7h">{open ? 'Close menu' : 'Open menu'}</span>
          </button>
        </div>
      </div>

      {open ? <div id="mobile-menu" className="border-t border-hairline bg-surface lg:hidden" data-id="element-63" data-mp="365wo8lsfxowc">
          <nav aria-label="Mobile" className="mx-auto max-w-[1320px] px-4 py-3 sm:px-6" data-id="element-64" data-mp="2r8xlbb8jak87">
            <ul className="flex flex-col" data-id="element-65" data-mp="2rb9zddb68afz">
              {NAV_LINKS.map(link => <li key={link.label} data-id="element-66" data-mp="2wa3f7cdxkdjb">
                  <a href={link.href} onClick={() => setOpen(false)} className="flex min-h-[48px] items-center border-b border-hairline-soft text-xs font-medium uppercase tracking-[0.16em] text-text-secondary transition-colors hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lime" data-id="element-67" data-mp="1ft8xkhnghh6c">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <CtaButton href={DEMO_URL} event="nav_book_demo_click" size="lg" className="my-4 w-full" onClick={() => setOpen(false)} data-id="element-68" data-mp="1mceobwtn64gg">
              Book a Demo
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-69" data-mp="2a0o7eqzh0e3w" />
            </CtaButton>
          </nav>
        </div> : null}
    </header>;
}